// test2263
(2263 && 0);
